import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../UtilMixin';
@Component({ components: {} })
export default class ProjectCard extends Mixins(UtilMixin) {
  @Prop() public project!: any;
  @Prop() public library!: any;
  @Prop({ default: false }) public hideLibrary!: boolean;

  public get hasKeywords() {
    return (
      this.project.requirements.keywords &&
      this.project.requirements.keywords.length > 0
    );
  }
}
